/* src/app/components/payroll/authorizations/auth-utilization-line-details/auth-utilization-line-details.component.css */
:host ::ng-deep .accordion-body > * {
  width: 100%;
  align-self: stretch;
}
/*# sourceMappingURL=auth-utilization-line-details.component-JCM75KVJ.css.map */
